import { useCallback, useEffect, useRef, useState } from "react";
import { twmRepository } from "../repositories/twm.repository";
import { shouldMakeAPICall } from "../utils/network";

export const useOfflineTWM = (authToken, userToken, page = 1) => {
  const [twmList, setTwmList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginationData, setPaginationData] = useState(null);
  const lastFetchKeyRef = useRef("");

  const load = useCallback(async () => {
    setLoading(true);

    const safePage = (() => {
      const n = Number(page);
      return Number.isFinite(n) && n > 0 ? n : 1;
    })();

    if (shouldMakeAPICall(authToken, userToken)) {
      const requestKey = `${String(userToken || "")}|${String(
        authToken || ""
      )}|${safePage}`;
      if (lastFetchKeyRef.current === requestKey) {
        setLoading(false);
        return;
      }
      lastFetchKeyRef.current = requestKey;

      try {
        await twmRepository.syncPendingActions(authToken);
      } catch (err) {
        console.error("TWM syncPendingActions failed:", err?.message);
      }

      try {
        const { list, meta } = await twmRepository.fetchPageFromAPI(
          authToken,
          userToken,
          safePage
        );

        setTwmList(Array.isArray(list) ? list : []);
        setPaginationData(
          meta
            ? {
                ...meta,
                current_page_count: meta.total_count ?? 0,
                page_count: meta.total_pages ?? 0,
              }
            : null
        );
      } catch (err) {
        console.error("TWM fetchPageFromAPI failed:", err?.message);
        const cached = await twmRepository.getFromCache();
        setTwmList(Array.isArray(cached) ? cached : []);
        setPaginationData(null);
      }
    } else {
      const cached = await twmRepository.getFromCache();
      setTwmList(Array.isArray(cached) ? cached : []);
      setPaginationData(null);
    }

    setLoading(false);
  }, [authToken, page, userToken]);

  useEffect(() => {
    load();
  }, [load]);

  return { twmList, loading, paginationData, refetch: load };
};

